/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import styled from '@emotion/styled'

import { Button, Icon, Message, MessageContent, MessageHeader, MessageItem, MessageList } from 'semantic-ui-react'
import { useContext } from 'react'
import { UltyModalWrapperContext } from '../../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const Container = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 1rem;
    margin-bottom: 2rem;
    margin-top: 1.5rem;
`

const MessageIcon = styled(Icon)`
    i.warning.circle.icon {
        font-size: 2em;
    }
`

const StyledMessage = styled(Message)`
    &.ui.yellow.icon.message {
        & > i.icon {
            font-size: 2em;
        }
        
        & > div.content > div.header {
            font-size: 1em;
        }
    }
`

const OrderPickupIncomplete = ({orderItems, onSubmit}) => {
    const [t] = useTranslation()
    const {handleUltyModalWrapper} = useContext(UltyModalWrapperContext)

    return (
      <>
          <Container>
              <StyledMessage
                color='yellow'
                icon
              >
                  <MessageIcon name='warning circle' />
                  <MessageContent>
                      <MessageHeader>
                        <p css={css`margin-bottom: 0.5em!important;`}>
                          {t('order.pickup.order_pickup_incomplete.avoid_dispute')}
                        </p>
                      </MessageHeader>
                      <MessageHeader>
                          {t('order.pickup.order_pickup_incomplete.some_products_are_missing',{count:orderItems.length})}
                      </MessageHeader>
                      <MessageList>
                          {orderItems.map(orderItem => <MessageItem key={orderItem.id}>{orderItem.item?.object?.name}</MessageItem>)}
                      </MessageList>
                  </MessageContent>
              </StyledMessage>
          </Container>

          <div style={{textAlign: 'center'}}>
              <Button
                fluid
                size='huge'
                color="teal"
                onClick={() => {
                    onSubmit()
                    handleUltyModalWrapper(false, null)
                }}
              >
                  {t('order.pickup.cancel')}
              </Button>
          </div>
      </>
    )
}


OrderPickupIncomplete.propTypes = {
    orderItems: PropTypes.arrayOf(
      PropTypes.shape({
          item: PropTypes.shape({
              object: PropTypes.shape({
                  name: PropTypes.string,
              }),
          }),
      }),
    ).isRequired,
    onSubmit: PropTypes.func.isRequired,
}

export default OrderPickupIncomplete
